// ** Icons Import
import { Home } from 'react-feather'

export default [
  {
    id: 'dashboard',
    title: 'Dashboard',
    action: 'view',
    resource: 'dashboard',
    icon: <Home size={20} />,
    navLink: '/dashboard'
  }
]
